import React from "react";

import { Container, Typography } from "@mui/material";

import video01 from "../../../assets/videos/Drugs01.mp4";

const Hero = props => {
  return (
    <section
      id="home"
      style={{
        position: "relative",
        height: "30vh",
        overflow: "hidden" // ซ่อนส่วนที่เกินของวิดีโอ
      }}
    >
      <video
        autoPlay
        muted
        loop
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover", // ปรับให้วิดีโอครอบคลุมพื้นที่
          zIndex: -1 // ทำให้วิดีโออยู่ด้านหลัง
        }}
      >
        <source src={video01} type="video/mp4" />
        {/* เพิ่มข้อความ fallback สำหรับเบราว์เซอร์ที่ไม่รองรับวิดีโอ */}
        Your browser does not support the video tag.
      </video>

      <Container
        sx={{
          pt: 15, // Padding-top ให้พ้นจาก AppBar
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          textAlign: "center",
          color: "white" // เปลี่ยนสีข้อความให้มองเห็นได้ชัดเจน
        }}
      >
        <Typography
          variant="h3"
          fontWeight="bold"
          gutterBottom
          sx={{
            background: "linear-gradient(45deg,rgb(221, 215, 215), #4ECDC4)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            fontSize: {
              xs: "2.2rem", //  มือถือ
              sm: "2.5rem", //  แท็บเล็ตแนวตั้ง
              md: "2.8rem" //  จอใหญ่หรือ Desktop
            }
          }}
        >
          {props.name}
        </Typography>
        {/* ข้อความภาษาไทย */}
        <Typography
          variant="h5"
          fontWeight="medium"
          sx={{
            color: "#ffffff",
            textShadow: "2px 2px 6px rgba(0, 0, 0, 0.5)",
            fontSize: {
              xs: "1.2rem", //  มือถือ
              sm: "1.5rem", //  แท็บเล็ตแนวตั้ง
              md: "1.5rem" //  จอใหญ่หรือ Desktop
            }
          }}
        >
          หน่วยสารเสพติด
        </Typography>
      </Container>
    </section>
  );
};

export default Hero;
